import { Theme, themeQuartz } from 'ag-grid-community';

import { fontAwesomeIcons } from './font-awesome-icons';

export const themeLv = themeQuartz.withPart(fontAwesomeIcons).withParams({
    // 2025 below
    accentColor: '#668800', // primary
    borderRadius: 8,
    browserColorScheme: 'light',
    checkboxBorderRadius: 2,
    fontFamily: 'var(--lv-font-sans)', // barvuy: variables in string format (not with a constant!!) are required, otherwise the variable (constant) is defined before the page is loaded and the ag-tokens are not overridden!
    fontSize: 14,
    headerFontFamily: 'var(--lv-font-sans)', // barvuy: variables in string format (not with a constant!!) are required, otherwise the variable (constant) is defined before the page is loaded and the ag-tokens are not overridden!
    headerFontSize: 14,
    headerFontWeight: 400,
    iconButtonBorderRadius: 16,
    iconSize: 16,
    oddRowBackgroundColor: '#fafafa',
    spacing: 4,
    wrapperBorder: true,
    wrapperBorderRadius: 8,
    autoHeightMinBodyHeight: 50, // sets height to 50px instead of 150px

    // NOTE casting to avoid bundling of internal module with ag grid 34
    // remove this later when ag grid fixes the issue
}) as Theme;
